(ns shared.core.account.data
  (:require [shared.core.reactive :as re]
            [shared.core.util :as util]))

(def account-path [:account])
(def user-path (conj account-path :user))
(def admin-role :admin)

(defn account-user [db]
  (get-in db user-path))

(re/reg-auth0-loader
  :account/load-user-details
  user-path
  {:method :get
   :url "/api/user"}
  :transf :body)

(re/reg-auth0-load-sub
  :account/user-details-
  user-path
  :account/load-user-details)

(re/reg-event-fx
  :account/toggle-setting
  re/middleware
  (fn [{:keys [local-storage]} [setting-key]]
    (let [p (conj account-path setting-key)]
      {:local-storage (update-in local-storage p not)})))

(re/reg-sub
  :account/setting-
  (fn [db [_ setting-key]]
    (get-in db [:local-storage :account setting-key])))

(defn account-user-roles [db]
  (some->> (util/when-not-loading (account-user db)) :roles (mapv keyword) (into #{})))

(re/reg-sub :account/user-roles- account-user-roles)

(defn account-user-concept-ids [db]
  (some->> (util/when-not-loading (account-user db)) :concept-ids))

(re/reg-sub :account/user-concept-ids- account-user-concept-ids)

(defn has-some-role? [user-roles required-roles]
  (let [roles (if (string? required-roles) [required-roles] required-roles)]
    (when (and (not-empty roles) (not-empty user-roles))
      (or (some #(contains? user-roles (util/->kebab-case-keyword %)) roles) (contains? user-roles admin-role)))))

(defn has-every-role? [user-roles required-roles]
  (let [roles (if (string? required-roles) [required-roles] required-roles)]
    (when (and (not-empty roles) (not-empty user-roles))
      (or (every? #(contains? user-roles (util/->kebab-case-keyword %)) roles) (contains? user-roles admin-role)))))

(re/reg-sub
  :account/has-some-role?-
  (fn [db [_ roles]]
    (has-some-role? (account-user-roles db) roles)))

(re/reg-sub
  :account/has-every-role?-
  (fn [db [_ roles]]
    (has-every-role? (account-user-roles db) roles)))

(re/reg-sub
  :account/admin-role?-
  (fn [db]
    (has-every-role? (account-user-roles db) [admin-role])))

(defn has-roles-access? [roles required-roles]
  (let [required-some-roles (when (some-> required-roles (first) (= :some))
                              (last required-roles))
        required-every-roles (when (some-> required-roles (first) (= :every))
                               (last required-roles))]
    (or (when (not-empty required-some-roles)
          (has-some-role? roles required-some-roles))
        (when (not-empty required-every-roles)
          (has-every-role? roles required-every-roles)))))

(re/reg-sub
  :account/has-roles-access?-
  (fn [db [_ required-roles]]
    (has-roles-access? (account-user-roles db) required-roles)))

(defn has-route-access? [routes route-k roles]
  (let [required-roles (some-> routes (get route-k) :roles)
        required-some-roles (when (some-> required-roles (first) (= :some))
                              (last required-roles))
        required-every-roles (when (some-> required-roles (first) (= :every))
                               (last required-roles))]
    (or (and (empty? required-some-roles) (empty? required-every-roles))
        (when (not-empty required-some-roles)
          (has-some-role? roles required-some-roles))
        (when (not-empty required-every-roles)
          (has-every-role? roles required-every-roles)))))
